import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LcpService } from 'src/app/services/lcp/lcp.service';
import { AuthService } from '../../auth.service';
 
@Injectable({
  providedIn: 'root'
})
export class ProductsResolverService implements Resolve<any> {

  constructor(
    private auth: AuthService,
    private lcpService : LcpService
    ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log('Fetching Accounts in route resolver...', route );
    
    //
    // When it's ready for the forkJoin... test more error handling
    //
    // const claimsRBS$ = this.auth.rbsClaims();
    // const account$ = this.lcpService.getAccounts();

    // return forkJoin([claimsRBS$,account$])


    //
    // Make Claims Identify
    //
    this.auth.rbsClaims()
    .subscribe( res=> {
      console.log( 'this.auth.rbsClaims() : ' + JSON.stringify(res));
    })

    //
    // getAccounts()
    //
    return this.lcpService.getAccounts().pipe(
      catchError(error => {
      return of(error);
          }
      )
  )


    //
    // Just to flag the workflow through
    //
    // let data = {
    //     Username : 'batman.co',
    //     SupportUsername : null,
    //     FortifyUserSourceType: 2,
    //     Accounts: [
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM HUNT/CLAYCO JV (A) TEST DATABASE - FEDERAL","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
    //         {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
    //         {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
    //         {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
    //         {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true}
    //       ]
    // }
    //  return of(data);

  }

}